export const GET_REGOLE_DI_APPLICAZIONE_DATA_AND_LOADING =
  "GET_REGOLE_DI_APPLICAZIONE_DATA_AND_LOADING";
export const EXPORT_REGOLE_LOADING = "EXPORT_REGOLE_LOADING";
export const CREATE_REGOLE_DI_APPLICAZIONE_DATA =
  "CREATE_REGOLE_DI_APPLICAZIONE_DATA";
export const CREATE_UPDATE_DELETE_REGOLE = "CREATE_UPDATE_DELETE_REGOLE";
export const GET_CURRENT_APPLICATION_RULE = "GET_CURRENT_APPLICATION_RULE";
